import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { NavLink, useLocation, useParams } from 'react-router-dom';

const PageBreadcrumb = () => {
  const { pathname } = useLocation();
  const { employeeId, teamId } = useParams();

  let pageName;

  if (pathname === "/") {
    pageName = "Dashboard"; // Display a specific name for the root path
  } else if (pathname == `/employee/${employeeId}`) {
    pageName = `Employee ${employeeId}`; // Display a specific name for the root path
  } else if (pathname == `/employees/${teamId}`) {
    pageName = `Team Employees`; // Display a specific name for the root path
  } else if (pathname === `/wfh`) {
    pageName = 'WFH'; // Display a specific name for the root path
  } else if (pathname === `/search`) {
    pageName = "Search Results"; // Display a specific name for the root path
  } else if (pathname === `/profile`) {
    pageName = "My Profile";
  } else {
    pageName = pathname.substring(pathname.lastIndexOf('/') + 1);
  }

  return (
    <div className="pagetitle">
      <h1>{pageName}</h1>
      <nav>
        <Breadcrumb>
          <Breadcrumb.Item as="li" linkAs='span'>
           <NavLink to="/">
            Home
           </NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {pageName}
          </Breadcrumb.Item>
        </Breadcrumb>
      </nav>
    </div>
  );
};

export default PageBreadcrumb;